import React from 'react';

/**
 * Renders either single-ayah view (with real-time word highlighting) or
 * full-page view (list of all ayahs). Pure presentational.
 */
export const AyahDisplay = ({
  isKidsMode,
  viewMode,            // 'single' | 'page'
  currentAyah,
  selectedAyahTo,
  ayahData,            // { text, translation } | null
  isRealtimeMode,
  realtimeTracking,    // { isTracking, currentWordIndex, errors }
  allAyahs,
}) => (
  <div
    className={`p-8 ${viewMode === 'page' ? 'text-right' : 'text-center'} ${
      isKidsMode
        ? 'bg-white rounded-3xl shadow-[0_8px_0_0_rgba(0,0,0,0.1)]'
        : 'bg-white/70 backdrop-blur-sm rounded-xl border border-stone-200'
    }`}
    data-testid="ayah-display"
  >
    {viewMode === 'single' ? (
      <>
        <div className="text-sm text-gray-500 mb-4">
          Ayet {currentAyah} / {selectedAyahTo}
        </div>

        <div className="text-4xl md:text-5xl font-arabic leading-loose mb-6" dir="rtl">
          {isRealtimeMode && realtimeTracking?.isTracking ? (
            ayahData?.text?.split(/\s+/).map((word, index) => {
              const isCurrentWord = index === realtimeTracking.currentWordIndex;
              const isPastWord = index < realtimeTracking.currentWordIndex;
              const hasError = realtimeTracking.errors.some((e) => e.position === index);
              return (
                <span
                  key={index}
                  className={`inline-block mx-1 px-2 py-1 rounded transition-all duration-300 ${
                    isCurrentWord
                      ? 'bg-yellow-200 border-2 border-yellow-500 scale-110'
                      : isPastWord
                      ? hasError
                        ? 'bg-red-100 text-red-700'
                        : 'bg-green-100 text-green-700'
                      : 'bg-gray-50'
                  }`}
                >
                  {word}
                </span>
              );
            })
          ) : (
            ayahData?.text
          )}
        </div>

        {ayahData?.translation && (
          <div className="text-gray-600 italic">{ayahData.translation}</div>
        )}
      </>
    ) : (
      <>
        <div className="text-sm text-gray-500 mb-4 text-center">
          Tüm Sayfa Görünümü - Mevcut Ayet: {currentAyah}
        </div>
        <div className="text-2xl md:text-3xl font-arabic leading-loose space-y-4" dir="rtl">
          {allAyahs.length > 0 ? (
            allAyahs.map((ayah) => (
              <div
                key={ayah.id}
                className={`p-3 rounded-lg transition-all ${
                  ayah.id === currentAyah
                    ? isKidsMode
                      ? 'bg-green-100 border-2 border-green-400'
                      : 'bg-emerald-100 border-2 border-emerald-600'
                    : 'hover:bg-gray-50'
                }`}
              >
                <span className="text-sm text-gray-500 ml-2">({ayah.id})</span>
                {ayah.text}
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500">Ayetler yükleniyor...</div>
          )}
        </div>
      </>
    )}
  </div>
);

export default AyahDisplay;
